// JOBE-0098.3: footer keystroke legend. Per-state keys enable / disable
// based on the active state ID — ⇧↩ in state 4 only (state 5 has no
// predicates by construction of pickState, so the `|| 'plain'` branch
// was dead), ⌘↩ in state 4 only.

export function Footer({ stateId, hasPredicates }) {
  const showShiftEnter = stateId === 'mixed' && hasPredicates;
  const showCmdEnter = stateId === 'mixed';
  // ⇥ accept only makes sense in state 3 (autocomplete) — there's
  // nothing to accept in states 2 (empty), 4 (mixed), or 5 (plain).
  // Per PR #696 LOW: don't lie to the user with unconditional hints.
  const showTabAccept = stateId === 'predicate';
  return (
    <div className="omni-pfoot" role="status">
      <span className="omni-keyhint"><kbd>↑</kbd><kbd>↓</kbd> navigate</span>
      {showTabAccept && (
        <span className="omni-keyhint"><kbd>⇥</kbd> accept</span>
      )}
      <span className="omni-keyhint"><kbd>↩</kbd> run</span>
      {showShiftEnter && (
        <span className="omni-keyhint"><kbd>⇧↩</kbd> apply as filters &amp; close</span>
      )}
      {showCmdEnter && (
        <span className="omni-keyhint"><kbd>⌘↩</kbd> save view…</span>
      )}
      <span className="omni-keyhint"><kbd>Esc</kbd> close</span>
    </div>
  );
}
